module.exports = __webpack_public_path__ + "img/6_42.64d89bb6.png";